import { combineReducers } from 'redux'
import RegisterAppointmentReducer from './register.appointment.reducer'
import RegisterInfoReducer from './register.info.reducer'

const RegisterReducer = combineReducers({
  info: RegisterInfoReducer,
  appointment: RegisterAppointmentReducer,
})

export default RegisterReducer